import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func } from 'prop-types'

const EARNINGS_TYPES = [
  { value: 'total', label: 'Total' },
  { value: 'regular', label: 'Regular' },
  { value: 'subscription', label: 'Subscription' },
]

function EarningsTypeToggle({ activeType, onTypeChange }) {
  return (
    <div className="overview-earnings-toggle">
      {EARNINGS_TYPES.map(({ value, label }) => (
        <Button
          key={value}
          type={activeType === value ? 'primary' : 'secondary'}
          size="small"
          customClass="overview-earnings-toggle__button"
          onClick={() => onTypeChange(value)}
        >
          {label}
        </Button>
      ))}
    </div>
  )
}

EarningsTypeToggle.propTypes = {
  activeType: string.isRequired,
  onTypeChange: func.isRequired,
}

export default EarningsTypeToggle
